import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {Alert, Box, CircularProgress, Snackbar, styled} from '@mui/material';

const Progress = styled(CircularProgress)({
  marginRight: 16,
});

const Notifier = ({
  open,
  message,
  progress,
  autoHideDuration = null,
  severity, // If you pass a severity, you will get alert stylings
  ...props
}) => {
  const [openState, setOpenState] = useState(open);

  useEffect(() => {
    setOpenState(open);
  }, [open]);

  function close(event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    setOpenState(false);
  }

  const content = progress ? (
    <Box alignItems="center" display="flex">
      <Progress size={24} />
      {message}
    </Box>
  ) : (
    message
  );

  return (
    <Snackbar
      autoHideDuration={autoHideDuration}
      onClose={close}
      open={openState}
      message={!severity && content}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      sx={{marginTop: 3}}
      data-testid="notifier-snackbar"
      {...props}
    >
      {severity && (
        <Alert
          sx={{width: '100%'}}
          onClose={close}
          elevation={6}
          variant="filled"
          severity={severity}
          data-testid="alert-snackbar"
          {...props}
        >
          {content}
        </Alert>
      )}
    </Snackbar>
  );
};

Notifier.propTypes = {
  autoHideDuration: PropTypes.number,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  open: PropTypes.bool.isRequired,
  progress: PropTypes.bool,
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
};

export default Notifier;
